import DOMPurify from 'dompurify';

const URL_REGEX = /(^|[\s>])((?:https?:\/\/|www\.)[^\s<]+)/gi;
const TRAILING_PUNCTUATION_REGEX = /[),.;!?]+$/;

const linkifyHtml = (content: string = '') => {
  const withLinks = content.replace(URL_REGEX, (_match, prefix: string, rawUrl: string) => {
    const trailingPunctuation = rawUrl.match(TRAILING_PUNCTUATION_REGEX)?.[0] ?? '';
    const url = trailingPunctuation ? rawUrl.slice(0, -trailingPunctuation.length) : rawUrl;
    const href = url.startsWith('www.') ? `https://${url}` : url;

    return `${prefix}<a href="${href}" target="_blank" rel="noopener noreferrer">${url}</a>${trailingPunctuation}`;
  });

  return DOMPurify.sanitize(withLinks, { ADD_ATTR: ['target', 'rel'] });
};

export const LinkifyHelper = {
  linkifyHtml,
};
